module.exports = __webpack_public_path__ + "media/launchable-detail1_720p4.06db9bb4.webm";